import * as sonbp from "sonbp";
import * as ifbase from "../../base";
import { drawCommon } from "..";
import { poscaPickupEditor } from "./poscaPickupEditor";
import { poscaVitem } from "./poscaVitem";

/**
* ポスカ用テキストアイテムのコンテンツエディター
* @summary ハンドル操作をピックアップで処理するように拡張しています。
*/
export class poscaTextEditor extends poscaPickupEditor {

	// -----------------------------------------------
	// Constructors（コンストラクタ）
	// -----------------------------------------------

	/**
	 * コンストラクタ
	 */
	public constructor(ifdto: ifbase.ifDto) {
		super(ifdto);
	}

	// -----------------------------------------------
	// Methods（外部アクセス用メソッド）
	// -----------------------------------------------

	/**
	 * 処理取得
	 * @override
	 */
	public take(select: sonbp.type.select): boolean {

		let p = super.take(select);

		let notake = (): boolean => {
			this._v._lm.unsetPickUpper(this);
			return false;
		}

		if (!p) return notake();

		if (!ifbase.util.chkIsText(select.items[0])) return notake();

		// 編集データ取得
		this._vitem = new poscaVitem(this._select.items[0]);

		//回転操作中だけフチは透明色にする
		this._vitem.itemEdge = this._vitem.item.clone() as sonbp.object.groupItem;
		ifbase.util.getItems(this._vitem.itemEdge.childs, function (item): boolean {

			if (item._sonbpItemType == sonbp.constant.sonbpItemType.path) {
				item.gstate.stroke_opacity = 0;
			}
			return false;
		});

		//ピックアップ
		this._v._dm.pickDraw();
		this._v._lm.setPickUpper(this, this._select.items[0]);

		this.init();
		return true;
	}

	// -----------------------------------------------
	// Methods（内部アクセス用メソッド）
	// -----------------------------------------------

	/**
	 * pickLayerCanvasへの描画
	 * @override
	 */
	public drawPickItem(co: sonbp.draw.canvasOperator): void {

		this._v._dm.pageTransform(this._select.pageIndex, co.ctx);

		// アイテム関連の描画
		co.ctx.save();
		{
			//方式① 無条件にmatrixで拡大描画
			let matrix = sonbp.util.c2d.matrixInverse(this._vitem.initial_matrix);
			matrix = sonbp.util.c2d.matrix2(matrix, this._vitem.apply_matrix);

			co.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
			let pmat = [1, 0, 0, 1, 0, 0];

			if ((this._state.type == 2 || this._state.type == 4) && this._vitem.itemEdge) {
				this._vitem.itemEdge.draw(co.ctx, undefined, undefined, pmat, true);
			} else {
				this._vitem.item.draw(co.ctx, undefined, undefined, pmat, true);
			}

			////方式② 拡大操作のみ都度計算して描画
			//if (this._preScaleValue == null) {

			//	let matrix = sonbp.util.c2d.matrixInverse(this._vitem.initial_matrix);
			//	matrix = sonbp.util.c2d.matrix2(matrix, this._vitem.apply_matrix);

			//	co.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
			//	let pmat = [1, 0, 0, 1, 0, 0];
			//	this._vitem.item.draw(co.ctx, undefined, undefined, pmat, true);

			//} else {
			//	let dummy = this._vitem.item.clone();
			//	let pts = dummy.points;
			//	dummy.scale(this._preScaleValue.sx, this._preScaleValue.sy);
			//	let pts2 = dummy.points;
			//	let mx = pts[4].x - pts2[4].x;
			//	let my = pts[4].y - pts2[4].y;
			//	dummy.move(mx, my);

			//	let pmat = [1, 0, 0, 1, 0, 0];
			//	dummy.draw(co.ctx, undefined, undefined, pmat, true);
			//}

		}
		co.ctx.restore();
	}

	/**
	 * eidtCanvasへの描画
	 * 再編集可能な非選択アイテムすべてに描写（2025年対応：配置済み画像の再編集可能 #28295）
	 */
	protected gdrawEditCanvas(co: sonbp.draw.canvasOperator): void {

		// 選択候補描画
		ifbase.constants.LTYPES_CAN_RESELECT.forEach(layerType => {

			let layer = ifbase.util.getLayer(this._ifdto, layerType).layer;
			let items = layer.items.filter(d => d.id != this._select.items[0].id)
			co.ctx.save();
			{
				drawCommon.drawCandidate(this._ifdto, co.ctx, items);
			}
			co.ctx.restore();
		});
	}

}
